import { Overlay as MantineOverlay } from '@mantine/core';

export const Overlay = MantineOverlay.extend({
	defaultProps: {},
});
